import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "display-order" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Display Order", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Order"),
    /*#__PURE__*/_createElementVNode("th", null, "Project Title")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Update Display Order")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitleComponent = _resolveComponent("PageTitleComponent")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_UserMessageComponent = _resolveComponent("UserMessageComponent")!
  const _component_PageActionsBarComponent = _resolveComponent("PageActionsBarComponent")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_PageContentComponent = _resolveComponent("PageContentComponent")!

  return (_openBlock(), _createBlock(_component_PageContentComponent, { class: "projects-settings-view" }, {
    default: _withCtx(() => [
      _createVNode(_component_PageTitleComponent, { title: "Projects Settings" }),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_LoadingComponent, { message: "Loading projects settings" })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_UserMessageComponent, { details: _ctx.loadUserMessage }, null, 8, ["details"]),
      (!_ctx.isLoading && !_ctx.loadUserMessage.isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_PageActionsBarComponent, {
              returnLink: "/projects",
              returnText: "Return to Projects"
            }),
            _createElementVNode("section", _hoisted_3, [
              _hoisted_4,
              (_ctx.settings !== null)
                ? (_openBlock(), _createBlock(_component_Draggable, {
                    key: 0,
                    modelValue: _ctx.settings.displayOrder,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settings.displayOrder) = $event)),
                    tag: "table",
                    "item-key": "reference",
                    class: "display-order-table hoverable"
                  }, {
                    header: _withCtx(() => [
                      _hoisted_5
                    ]),
                    item: _withCtx(({element}) => [
                      _createElementVNode("tr", null, [
                        _hoisted_6,
                        _createElementVNode("td", null, _toDisplayString(element.title), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ButtonComponent, { onClick: _ctx.onUpdateDisplayOrder }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_UserMessageComponent, { details: _ctx.displayOrderUserMessage }, null, 8, ["details"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}